module.exports = __webpack_public_path__ + "img/Expired.035724c5.png";